import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  ExternalLink, Clock, Mail, MessageCircle, Globe, Calendar, Lock,
  Users, Flag, Trophy, Zap, Smartphone
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo2 from "@assets/logos_extracted/2.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://all.monvaki.com/?mid=282906_1667056";

const tabs = [
  { id: "platby",      label: "Platby",               icon: CreditCard },
  { id: "hry",         label: "Hry",                  icon: Gamepad2 },
  { id: "podpora",     label: "Zákaznická podpora",   icon: HeadphonesIcon },
  { id: "obecne",      label: "Obecné informace",     icon: Info },
  { id: "zodpovedne",  label: "Zodpovědné hraní",     icon: Heart },
];

const depositMethods = [
  "PlayID", "Visa", "Mastercard", "Paysafecard", "Apple Pay", "Sofort",
  "Skrill", "Nuvei", "Neteller", "Jetonbank", "MiFinity",
  "USDTether TRC20", "USDTether ERC20", "USDTether BEP20",
  "Bitcoin", "Ethereum", "Litecoin", "Solana", "BNB", "Ripple",
  "Bitcoin Cash", "Dogecoin", "Cardano",
];

const withdrawalMethods = [
  "PlayID", "Visa", "Mastercard", "Bank Transfer", "Revolut",
  "Skrill", "Nuvei", "Neteller", "Jetonbank", "MiFinity",
  "USDTether TRC20", "USDTether ERC20", "USDTether BEP20",
  "Bitcoin", "Ethereum", "Litecoin", "Solana", "BNB",
  "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const providers = "1X2 Gaming, 3 Oaks Gaming, 7777 Gaming, All41 Studios, Amatic Industries, Amusnet (EGT), Apollo Games, Arcade, Atmosfera, Belatra Games, Betsoft, Betsolutions, BF Games, BGAMING, Bombay Live, Booming Games, BTG (Big Time Gaming), Caleta Gaming, Casino Technology, Claw, ELA Games, ELK Studios, Endorphina, Evolution Gaming, Evoplay Entertainment, Ezugi, Felix Gaming, Felt, Foxium, Fugaso, G.Games, Gamebeat, Gameburger Studios, Gaming Corps, Gaming Realms, Gamomat, Gamzix, Golden Rock Studios, Habanero, Hacksaw Gaming, High 5 Games, InBet Games, InOut, IronDog, JFTW (Just For The Win), KA Gaming, Kalamba Games, Kiron Interactive, Leap Gaming, Lucky Streak, Mascot Gaming, Mercury, Microgaming, NetEnt, NetGaming, Nolimit City, Novomatic, Nucleus Gaming, Octoplay, OnAir, OneTouch, Onlyplay, Oryx, Platipus, Play'n GO, PlayPearls, Playson, Playtech, Pocket Games Soft, Pragmatic Play, Pragmatic Play Live, Quickspin, Real Dealer Studios, Red Rake Gaming, Red Tiger Gaming, Relax Gaming, Revolver Gaming, Rogue Gaming, Ruby Play, Salsa Technology, Slotmill, Smartsoft Gaming, Spinmatic, Spinomenal, Spribe, StakeLogic, Stormcraft Studios, Swintt, Switch Studios, Thunderkick, Tom Horn Gaming, Triple Edge Studios, Turbo Games, Vibra Gaming, Wazdan, Woohoo, Yggdrasil, Zillion, LEMON";

const pros = [
  "Velký výběr her (10 000+)",
  "Lokální platební metody včetně Paysafecard",
  "Nonstop zákaznická podpora (angličtina, němčina přes překladač)",
  "VIP program s cashbackem a vyššími limity",
  "Apple Pay, kryptoměny a další moderní platební metody",
];

const cons = [
  "Mírně nižší RTP než u některých konkurentů",
  "Standardní výběrový limit 175 000 Kč/měsíc",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>3 dny</span></div>
        <div className={rowClass}><span className={labelClass}>Výběrový limit:</span><span className={valueClass}>175 000 Kč/měsíc (VIP až 500 000 Kč)</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <span className={valueClass}>PlayID, Visa, Mastercard, Paysafecard, Apple Pay, Sofort, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDTether TRC20, USDTether ERC20, USDTether BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <span className={valueClass}>PlayID, Visa, Mastercard, Bank Transfer, Revolut, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDTether TRC20, USDTether ERC20, USDTether BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 11 000 her</span></div>
        <div className={rowClass}><span className={labelClass}>Automaty:</span><span className={valueClass}>Více než 10 000 výherních automatů</span></div>
        <div className={rowClass}><span className={labelClass}>Živé stoly:</span><span className={valueClass}>Ano – ruleta, blackjack, baccarat, game show</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>RTP:</span><span className={valueClass}>94–96 %</span></div>
        <div className={rowClass}><span className={labelClass}>Poskytovatelé her:</span><span className={valueClass}>{providers}</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@allyspin.com</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>GMBL Tech / Stellar Ltd.</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://allyspin.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">allyspin.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2026</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>GMBL Tech / Stellar Ltd.</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan Gaming Authority (č. ALSI-152406028-FI2)</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky:</span><span className={valueClass}>Čeština, Angličtina, Němčina, Španělština, Francouzština, Italština, Polština, Norština, Finština, Maďarština, Slovenština, Slovinština, Nizozemština, Arabština, Řečtina, Portuguesa</span></div>
        <div className={rowClass}><span className={labelClass}>Omezené země:</span><span className={valueClass}>Afghánistán, Arménie, Bělorusko, Bulharsko, Čína, Curaçao, Kypr, Dánsko, Estonsko, Gruzie, Írán, Irák, Izrael, Litva, Malta, Moldavsko, Myanmar, Rumunsko, Rusko, Severní Korea, Nizozemsko, Švédsko, Ukrajina, Spojené království, USA</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Limit sázek:", "Ano"],
      ["Limit ztrát:", "Ano"],
      ["Časový limit hraní:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["Dočasná pauza:", "Ano"],
      ["Kontrola reality:", "Ne"],
      ["Sebehodnoticí test:", "Ne"],
      ["Blokace výběrů:", "Ne"],
      ["Registr sebevyloučení:", "Ne"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={`${valueClass} ${value === "Ano" ? "text-green-600" : value === "Ne" ? "text-gray-400" : ""}`}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function AllyspinPage() {
  useSEO({ title: "AllySpin Casino Recenze 2026 – Bonus a výběr her | HrajBonus", description: "Nezávislá recenze AllySpin Casino. Uvítací bonus, velký výběr slotů i live her, zákaznická podpora 24/7. Hodnocení od expertů. 18+",
  url: "https://hrajbonus.com/kasina/allyspin", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              {/* Left: logo + name + meta */}
              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo2} alt="Allyspin logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Allyspin</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                {/* Rating stars */}
                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4,5].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                  </div>
                  <span className="text-white font-bold text-xl">9.7</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                {/* Key stats */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her", value: "11 000+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Minimální výběr", value: "250 Kč" },
                    { label: "Licence", value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              {/* Right: CTA card */}
              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 25 000 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Allyspin" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            {/* ── Main content column ───────────────────────── */}
            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.7</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Allyspin vstoupilo na trh v roce 2026 s jasnou ambicí: nabídnout hráčům bohaté portfolio her, lokálně přívětivé platební metody a spolehlivou zákaznickou podporu dostupnou nonstop. Za krátkou dobu si kasino vybudovalo solidní reputaci, opírajíc se o zkušenosti provozního týmu z desítek dalších projektů. Výsledkem je platforma, která funguje promyšleně a přehledně.
                </p>

                {/* Pros/Cons inline */}
                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Přehled kasina tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Heading + intro */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Allyspin Casino recenze 2026: bonusy a bezpečné hraní pro české hráče
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Allyspin Casino je nové online kasino provozované společností Stellar Ltd., které vstoupilo na trh v roce 2026. Kasino funguje na základě licence od Anjouan Gaming Authority (číslo ALSI-152406028-FI2). Tato licence je srovnatelná s dobře známou licencí z Curaçaa – vyžaduje férovou hru, vyplácení výher a ochranu hráčů. Výhodou je možnost obrátit se přímo na regulátora prostřednictvím stížnostního formuláře, pokud by došlo k problémům.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Provozovatel Stellar Ltd. má zkušenosti s více než 25 dalšími online kasiny a jeho značky jsou mezi hráči známé. Allyspin tak staví na zkušenostech týmu, který již dříve spravoval populární projekty jako Wazamba nebo Legiano Casino.
                </p>

                {/* What we tested */}
                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co jsme testovali</div>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {["Herní knihovna", "Bonusy & VIP", "Platby & výběry", "Mobilní verze", "Podpora"].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>

                <a href="#bonusy">
                  <Button variant="outline" className="hraj-btn-light font-semibold gap-2 text-[#003da5]" data-testid="button-bonusy">
                    Přejít na bonusy <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
              </div>

              {/* Games library */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hry a software: víc než jen čísla</h2>

                <p className="text-gray-600 leading-relaxed mb-4">
                  Hráči zde najdou téměř 10 000 výherních automatů a živých stolů od vývojářů jako Pragmatic Play, NetEnt, Evolution, Ezugi, Play'n GO nebo Nolimit City. RTP her se obvykle pohybuje mezi 94–96 %, což je o něco méně než u některých konkurentů.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Katalog pokrývá prakticky vše, co moderní hráč hledá – od klasických ovocných automatů přes megaways tituly s rozšiřujícími se válci až po sofistikované živé hry s krupiéry. Živá sekce nabízí ruletu, blackjack, baccarat i oblíbené game show v různých limitech.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Silnou stránkou je portfolio providerů: Gamomat, Merkur a Novomatic dodávají ověřené klasiky, zatímco ELK Studios, Hacksaw Gaming a Nolimit City zásobují lobby čerstvými vysokovolatilními kousky. Výsledkem je katalog, ve kterém si přijdou na své konzervativci i lovci adrenalinových sezení.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co v knihovně stojí za pozornost:</div>
                  <div className="space-y-2">
                    {[
                      "Více než 10 000 výherních automatů a živých stolů s krupiéry",
                      "Prémiové hry od Gamomat, Merkur a Novomatic",
                      "Živé stoly od Evolution Gaming a Ezugi",
                      "Vysokovolatilní novinky od Hacksaw Gaming a Nolimit City",
                      "Sportovní sázení a eSports pod jedním účtem",
                    ].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* UX + Mobile */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Uživatelské prostředí a mobilní hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rozhraní Allyspin působí čistě a přehledně. Filtry podle poskytovatele, kategorie i volatility usnadňují navigaci i v tak rozsáhlém katalogu. Hledání pracuje rychle a miniatury her mají čistý vizuál. Stránka reaguje svižně – pár minut a víte, kde co najdete.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Na mobilních zařízeních kasino běží plynule. Web je plně responzivní a optimalizovaný jak pro iOS, tak pro Android. Animace nepřekáží, texty jsou čitelné a tlačítka mají přiměřenou velikost. Sloty startují bez zbytečných prodlev a živé stoly si drží stabilní video stream i na mobilních datech.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Nepřetržitá zákaznická podpora přes e-mail i live chat zajišťuje, že pomoc je vždy po ruce – ať si hráč sedí u počítače, nebo hraje na cestách z telefonu.
                </p>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a promoakce</h2>

                <h3 className="font-bold text-gray-900 text-base mb-3">Uvítací bonus (aktuální nabídka)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Allyspin v době psaní nabízí uvítací bonus k prvnímu vkladu (částky a případné free spiny jsou komunikovány přímo v Kč v sekci Můj účet → Moje bonusy). Jelikož jde o novou značku a promoakce se mohou upravovat, doporučujeme ověřit přesné znění bonusu přímo po registraci v profilu hráče. Neuvádíme zde konkrétní částky, aby byly informace maximálně přesné a aktuální.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak bonus aktivovat</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Vytvořte účet a ověřte e-mail/telefon.",
                      "V profilu otevřete Moje bonusy a zvolte uvítací nabídku.",
                      "Proveďte první vklad v Kč (minimální výše a případný kód jsou uvedeny u bonusu).",
                      "Bonus se připíše po splnění uvedených podmínek; free spiny (pokud jsou součástí) najdete u vybraného automatu.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                </div>

                <div className="mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Na co si dát pozor (typické podmínky)</div>
                  <ul className="space-y-2">
                    {[
                      "Požadavky na protočení: bonusové prostředky a výhry z free spinů je obvykle nutné několikrát protočit; přesné násobky najdete u nabídky.",
                      "Maximální sázka při protočení: bývá omezená; kontrolujte limit v Kč v pravidlech bonusu.",
                      "Příspěvky her: sloty obvykle 100 %, stolní a živé hry méně; jackpoty se často nepočítají.",
                      "Časová platnost: bonus i free spiny mívají časový limit; sledujte odpočet v profilu.",
                      "Způsobilé hry a země: některé automaty mohou být vyloučeny; platí i regionální omezení.",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <Trophy className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    <span className="font-bold text-[#003da5]">Rychlá odpověď:</span> Ano, Allyspin má uvítací bonus v Kč k prvnímu vkladu. Konkrétní výše a podmínky se zobrazují v Moje bonusy po přihlášení.
                  </p>
                </div>

                <h3 className="font-bold text-gray-900 text-base mb-3">Pravidelné promoakce a VIP</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Po dočerpání uvítací nabídky lze počítat s běžnými akcemi jako reload bonusy, free spiny, turnaje a VIP program s více úrovněmi. VIP výhody typicky zahrnují cashback a vyšší měsíční limity výběru; detailní podmínky jsou k dispozici v sekci VIP v profilu.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  <span className="font-semibold text-gray-800">Poznámka k měně:</span> Všechny bonusy a limity jsou zobrazovány a vypláceny v Kč.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  <span className="font-semibold text-gray-800">Odpovědné hraní:</span> Využívejte bonusy s rozvahou, nastavte si sebeomezující limity (vklad, ztráta, čas). Pouze pro hráče 18+. Hrajte zodpovědně.
                </p>

                <div className="mt-5 pt-5 border-t border-[#eef1f7]">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co dělá bonusy Allyspin zajímavé</div>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {[
                      "Uvítací bonus v Kč přímo v profilu",
                      "Přehledné podmínky protočení (35× bonus / 40× FS)",
                      "Pravidelné reload akce pro stálé hráče",
                      "VIP cashback a vyšší výběrové limity",
                      "Turnaje s transparentním žebříčkem",
                      "Exkluzivní uvítací bonus až 25 000 Kč",
                    ].map(item => (
                      <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platby, měny a kryptoměny</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Kasino podporuje širokou paletu plateb: Apple Pay, Paysafecard, Sofort, MiFinity i kryptoměny. Minimální vklad je 500 Kč, výběrový limit 175 000 Kč měsíčně s možností navýšení až na 500 000 Kč pro VIP hráče. Rychlost výplat se pohybuje kolem 3 dnů, přičemž kryptoměnové transakce bývají rychlejší.
                </p>

                {/* Payment methods */}
                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllDeposit(!showAllDeposit)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllWithdrawal(!showAllWithdrawal)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                {/* Speed table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Metoda</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Odeslání výhry</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Poplatek ze strany kasina</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["E-peněženky (Skrill, Neteller)", "do 24–48 hodin", "ne"],
                        ["Platební karta", "1–3 pracovní dny", "ne"],
                        ["Bankovní převod", "1–5 pracovních dní", "ne"],
                        ["Kryptoměny", "téměř okamžitě po schválení", "ne"],
                      ].map(([method, speed, fee], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-3 font-medium text-gray-900">{method}</td>
                          <td className="px-4 py-3 text-gray-600">{speed}</td>
                          <td className="px-4 py-3 text-gray-400">{fee}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Customer support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora 24/7</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Allyspin zajišťuje nepřetržitou zákaznickou podporu přes e-mail i live chat. Kontakt je dostupný 24 hodin denně, 7 dní v týdnu. Živý chat reaguje zpravidla rychle, e-mail je vhodný pro složitější požadavky. Kasino nenabízí telefonickou linku, což je v dnešním online prostředí standardní.
                </p>

                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7, rychlé reakce</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@allyspin.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">není k dispozici</div>
                    </div>
                  </div>
                </div>

                <p className="text-gray-500 text-sm mt-4 leading-relaxed">
                  Chat řeší drtivou většinu situací – od přehledu bonusových podmínek po technické rady u plateb. Absence telefonní linky v roce 2026 nepředstavuje reálnou nevýhodu.
                </p>
              </div>

              {/* Safety */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost, licence a kontrola nad hraním</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Allyspin provozuje svou činnost na základě licence Anjouan Gaming Authority (ALSI-152406028-FI2), která vyžaduje férovou hru, řádné vyplácení výher a ochranu hráčů. V případě problémů se hráč může obrátit přímo na regulátora prostřednictvím stížnostního formuláře.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Bezpečnostní stránka je solidní: 256bitové SSL šifrování, transparentní práce s osobními daty a hry od certifikovaných studií s ověřeným RNG. To zaručuje konzistentní generování náhodných výsledků.
                </p>

                <div className="font-bold text-gray-900 text-sm mb-3">Nástroje pro odpovědné hraní:</div>
                <div className="grid sm:grid-cols-2 gap-2 mb-5">
                  {[
                    "Limity vkladů, sázek a ztrát",
                    "Časové limity a připomínky sezení",
                    "Dočasná pauza nebo delší sebevyloučení",
                    "Přímý kontakt na regulátora v případě sporu",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nastavení limitů je rychlé a změny se projeví bez zbytečného čekání. Hrajte zodpovědně a vždy jen tolik, kolik si můžete dovolit ztratit.
                </p>
              </div>

              {/* For whom */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Pro koho je Allyspin dobrou volbou</h2>
                <div className="space-y-2">
                  {[
                    "Pro hráče, kteří chtějí velký výběr automatů na jednom místě (10 000+)",
                    "Pro uživatele preferující lokální platební metody jako Paysafecard nebo Sofort",
                    "Pro milovníky moderních plateb – Apple Pay a kryptoměny plně podporovány",
                    "Pro ty, kteří chtějí dostupnou nonstop podporu přes live chat",
                    "Pro hráče se zájem o VIP program s cashbackem a vyššími výběrovými limity",
                    "Pro ty, kteří oceňují kasino s transparentní licencí a zkušeným provozovatelem",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Final Pros/Cons */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a nevýhody v kostce</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                      <CheckCircle className="w-4 h-4" /> Výhody
                    </div>
                    <ul className="space-y-2">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold text-base leading-none mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                      <XCircle className="w-4 h-4" /> Nevýhody
                    </div>
                    <ul className="space-y-2">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold text-base leading-none mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <p className="text-gray-500 text-sm mt-5 leading-relaxed">
                  Obě nevýhody jsou v kontextu trhu zcela standardní. Nižší RTP je kompenzováno šíří nabídky a silným portfoliem providerů. Výběrový limit 175 000 Kč/měsíc je pro drtivou většinu hráčů více než dostačující.
                </p>
              </div>

              {/* Tips */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Tipy pro plynulý start v Allyspin</h2>
                <ul className="space-y-2.5">
                  {[
                    "Ověřte si e-mail ihned po registraci, urychlí to první výběr",
                    "Pro bonus vkládejte kartou, bankou nebo kryptoměnou",
                    "Nastavte limity vkladů a délky sezení hned na začátku",
                    "Přidejte oblíbené hry do záložek pro rychlý přístup",
                    "Sledujte sekci Moje bonusy – tam najdete aktuální nabídky v Kč",
                  ].map((tip, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-gray-600 text-sm">
                      <Zap className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                      {tip}
                    </li>
                  ))}
                </ul>

                <div className="mt-5 pt-5 border-t border-[#eef1f7]">
                  <h3 className="font-bold text-gray-900 text-sm mb-3">Check-list pro plynulý start</h3>
                  <div className="space-y-2">
                    {[
                      "Registrace a ověření e-mailu",
                      "Nastavení bezpečnostních prvků účtu",
                      "Výběr vhodné platební metody (pro bonus kartou/bankou/kryptem)",
                      "Aktivace uvítacího bonusu v sekci Moje bonusy",
                      "Přidání oblíbených her do záložek",
                      "Zapnutí limitů vkladů a délky sezení",
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-2.5 text-gray-700 text-sm">
                        <div className="w-5 h-5 rounded border-2 border-[#003da5] flex items-center justify-center flex-shrink-0">
                          <CheckCircle className="w-3 h-3 text-[#003da5]" />
                        </div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Conclusion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <p className="text-gray-700 leading-relaxed">
                  Allyspin Casino v roce 2026 přichází jako promyšlená platforma se silným zázemím zkušeného provozovatele. Rozsáhlé portfolio her, přívětivé platební možnosti pro český trh, nepřetržitá podpora a exkluzivní uvítací bonus až 25 000 Kč z něj dělají atraktivní volbu pro hráče, kteří chtějí kvalitu a spolehlivost pod jednou střechou.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                {/* CTA card */}
                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo2} alt="Allyspin" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Allyspin</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4,5].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <span className="text-gray-600 text-xs ml-1">9.7/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 25 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                {/* Quick info */}
                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,     label: "Web",        value: "allyspin.com" },
                      { icon: Calendar,  label: "Rok",        value: "2026" },
                      { icon: Lock,      label: "Licence",    value: "Anjouan" },
                      { icon: Users,     label: "Provozovatel", value: "Stellar Ltd." },
                      { icon: Gamepad2,  label: "Počet her",  value: "11 000+" },
                      { icon: Clock,     label: "Podpora",    value: "24/7 Live chat" },
                      { icon: CreditCard, label: "Min. vklad", value: "250 Kč" },
                      { icon: Zap,       label: "Výplaty",    value: "Do 48 h (e-wallet)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="allyspin" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/onlyspins" className="text-[#003da5] hover:underline" data-testid="review-link-onlyspins">OnlySpins</a>
              {" · "}
              <a href="/kasina/nomini" className="text-[#003da5] hover:underline" data-testid="review-link-nomini">Nomini</a>
              {" · "}
              <a href="/kasina/spinanga" className="text-[#003da5] hover:underline" data-testid="review-link-spinanga">Spinanga</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
